var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"raca","rota-base":"/admin/raca","titulo-singular":"Raça/Cor","campos-extras":[{"campo":"cod_censo","label":"Código INEP","tipo":"int","descricao":"Código do INEP/Educacenso (0=Não declarada, 1=Branca, 2=Preta, 3=Parda, 4=Amarela, 5=Indígena)"}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }